export const searchableSelectCheck = (value, valueSpec) => {
  if (!valueSpec || !valueSpec.enums) {
    return false;
  }
  if (!value) {
    return false;
  }
  if (valueSpec.enums.indexOf(value) === -1) {
    return false;
  }
  if (valueSpec.valueCheck !== undefined) {
    if (!valueSpec.valueCheck && valueSpec.value === value) {
      return false;
    }
  }
  return true;
};
